<template>
  <div class="tooltip">
    <slot name="trigger" />
    <div class="tooltipContent">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'Tooltip',
};
</script>
<style lang="scss" scoped>
@import './TooltipStyle.scss';
</style>
